import { render, staticRenderFns } from "./PrettyTime.vue?vue&type=template&id=f77fd63e&"
import script from "./PrettyTime.vue?vue&type=script&lang=js&"
export * from "./PrettyTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports